module.exports = __webpack_public_path__ + "939e8d1e6146940d3470d44c3d4be253.eot";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/opensans-bold-webfont.eot
// module id = 132
// module chunks = 0